import { createFileRoute, redirect } from "@tanstack/react-router";
import { blackScheduledHref } from "@/lib/black2x1/offer-rules";
import { BlackQuizzPage } from "@/components/black2x1/BlackQuizzPage";
import logoOficial from "@/assets/black2x1/black-logo-oficial.webp.asset.json";

const URL = "https://fisioemortopedia.com.br/black-quizz";
const OG_IMAGE = `https://fisioemortopedia.com.br${logoOficial.url}`;
const TITLE = "BLACK FEO 2026 · Descubra sua condição na Pós em Dobro";
const DESC = "Responda duas perguntas e veja como funciona a sua condição na BLACK da FEO 2026: 2 pós-graduações pelo preço de 1, com Star Cursos vitalícia.";

export const Route = createFileRoute("/black-quizz")({
  beforeLoad: ({ location }) => {
    const destination = blackScheduledHref(location.href, Date.now());
    if (destination !== location.href) throw redirect({ href: destination, statusCode: 302 });
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { name: "robots", content: "noindex,follow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: logoOficial.url, fetchPriority: "high" },
    ],
  }),
  component: BlackQuizzPage,
});
